import {
  GET_CONTRACT_FILE,
  GET_CONTRACT_FILE_SUCCESS,
  GET_CONTRACT_FILE_FAILURE,
} from 'store/getContractFile/getContractFileAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getContractFileReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTRACT_FILE:
      return { ...state, loading: true };
    case GET_CONTRACT_FILE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_CONTRACT_FILE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getContractFileReducer;
